import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { AppCoreModule } from "./core/core.module";
import { SharedModule } from "./shared/shared.module";
import { SecurityModule } from "./security/security.module";
import { AngularFireModule } from "@angular/fire";
import { environment } from "src/environments/environment";
import { UserModule } from "./user/user.module";
import { HttpClientModule } from "@angular/common/http";
import {
  AngularFirestoreModule,
  AngularFirestore
} from "@angular/fire/firestore";
import { ServiceProviderModule } from "./service-provider/service-provider.module";
import { FacebookModule } from 'ngx-facebook';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AppCoreModule,
    SharedModule,
    SecurityModule,
    HttpClientModule,
    UserModule,
    ServiceProviderModule,
    AngularFirestoreModule,
    FacebookModule.forRoot(),
    AngularFireModule.initializeApp(environment.firebase)
  ],
  providers: [AngularFirestore],
  bootstrap: [AppComponent]
})
export class AppModule {}
